export function buildAppLoginUrl(href = window.location.href) {
  const url = new URL(href);
  url.pathname = `${url.pathname.replace(/\/+/g, "/").replace(/\/+$/, "")}/`;
  url.search = "";
  url.hash = "/account/sign-in";
  return url.href;
}
